import { StatusItem } from './status.types';
import api from '../../utils/api';

const STORAGE_KEY = 'mc_status_config';

const SYSTEM_STATUSES: StatusItem[] = [
  { id: '01', name: 'Setor/Usuário', isSystem: true },
  { id: '02', name: 'Aguardando', isSystem: true },
  { id: '03', name: 'Coleta', isSystem: true },
  { id: '04', name: 'Instalação', isSystem: true },
  { id: '05', name: 'Entregar', isSystem: true },
  { id: '06', name: 'Retirar', isSystem: true },
  { id: '07', name: 'Finalizado', isSystem: true },
  { id: '08', name: 'Atrasado', isSystem: true },
];

export class StatusController {
  private static resequence(list: StatusItem[]): StatusItem[] {
    return list.map((item, index) => ({
      ...item,
      id: String(index + 1).padStart(2, '0')
    }));
  }

  static list(): StatusItem[] {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      if (!data) {
        const initial = [
          ...SYSTEM_STATUSES,
          { id: '09', name: 'Levar p/ transportadora', isSystem: false, colorHex: '#0dcaf0', description: 'Agendado para envio via parceiro logístico' },
          { id: '10', name: 'Alteração de data', isSystem: false, colorHex: '#ffc107', description: 'Alteração de data acordada' }
        ];
        localStorage.setItem(STORAGE_KEY, JSON.stringify(initial));
        return initial;
      }
      const parsed = JSON.parse(data) as StatusItem[];
      // Garantir que todos de SYSTEM_STATUSES estão incluídos
      const missing = SYSTEM_STATUSES.filter(sys => !parsed.some(p => p.name.toLowerCase() === sys.name.toLowerCase()));
      if (missing.length > 0) {
        const updated = this.resequence([...SYSTEM_STATUSES, ...parsed.filter(p => !p.isSystem)]);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
        return updated;
      }
      return parsed;
    } catch {
      return SYSTEM_STATUSES;
    }
  }

  static async fetchList(): Promise<StatusItem[]> {
    try {
      const response = await api.get('/statuses');
      const customStatuses = response.data.map((item: any) => ({
        id: '', // Will be resequenced
        name: item.name,
        isSystem: false,
        dbId: item.id,
        colorHex: item.colorHex || item.color_hex || '#6c757d',
        description: item.description || ''
      }));

      const combined = [...SYSTEM_STATUSES, ...customStatuses];
      const resequenced = this.resequence(combined);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(resequenced));
      return resequenced;
    } catch (err) {
      console.error("Erro ao carregar status do servidor, usando cache local:", err);
      return this.list();
    }
  }

  static async save(
    id: string | null,
    name: string,
    colorHex?: string,
    description?: string
  ): Promise<StatusItem[]> {
    let dbId: number | undefined = undefined;

    if (id) {
      const list = this.list();
      const existing = list.find(s => s.id === id);
      if (existing) {
        dbId = existing.dbId;
      }
    }

    try {
      await api.post('/statuses', {
        id: dbId,
        name: name.trim(),
        colorHex: colorHex || '#6c757d',
        description: description || ''
      });
    } catch (err) {
      console.error("Erro ao salvar status no servidor:", err);
    }

    return this.fetchList();
  }

  static async delete(id: string, name: string): Promise<StatusItem[]> {
    const list = this.list();
    const existing = list.find(s => s.id === id && s.name === name);
    if (existing && existing.dbId) {
      try {
        await api.post('/statuses/delete', { id: existing.dbId });
      } catch (err) {
        console.error("Erro ao excluir status no servidor:", err);
      }
    }
    return this.fetchList();
  }
}
